module.exports = __webpack_public_path__ + "img/work1.84d9e73b.png";